/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.querySelector('.thb-quick-search');
    this.button = document.getElementById('quick-search');
    this.close_button = this.container?.querySelector('.thb-search-close');
    this.input = this.getSearchInput();
    this.predictiveSearchResults = this.container?.querySelector('.thb-quick-search--results');

    if (!this.container || !this.button) {
      return;
    }

    this.setupEventListeners();
  }

  getSearchInput() {
    if (!this.container) {
      return null;
    }
    if (window.isB2B) {
      return (
        this.container.querySelector('input[type="search"]') ||
        this.container.querySelector('.search-field')
      );
    }
    return (
      this.container.querySelector('.aa-Input') ||
      this.container.querySelector('input[type="search"]') ||
      this.container.querySelector('.search-field')
    );
  }

  setupEventListeners() {
    const form = this.container.querySelector('form.searchform');
    form?.addEventListener('submit', this.onFormSubmit.bind(this));

    // Algolia may mount after PredictiveSearch initializes — re-resolve input on open.
    const bindInputListener = () => {
      this.input = this.getSearchInput();
      if (!this.input || this.input.dataset.predictiveBound === 'true') {
        return;
      }
      this.input.dataset.predictiveBound = 'true';
      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
    };
    bindInputListener();
    if (!window.isB2B) {
      // Retry once Algolia autocomplete is ready.
      document.addEventListener('algolia.hooks.initialize', () => {
        setTimeout(bindInputListener, 50);
      });
    }
    setTimeout(bindInputListener, 1500);

    this.button.addEventListener('click', (event) => {
      var _this = this;
      event.preventDefault();
      document.querySelector('.header-section').classList.toggle('search-open');

      if (document.querySelector('.header-section').classList.contains('search-open')) {
        setTimeout(function () {
          _this.input = _this.getSearchInput();
          _this.input?.focus({
            preventScroll: true
          });
        }, 100);
        dispatchCustomEvent('search:open');
      } else {
        this.closeAlgoliaPanel();
      }

      return false;
    });

      // Close.
      this.close_button?.addEventListener('click', (event) => {
      this.close();
      event.preventDefault();
    });
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        this.close();
      }
    });
  }

  closeAlgoliaPanel() {
    if (window.isB2B) {
      const input = this.getSearchInput();
      if (input) {
        input.value = '';
        input.blur();
      }
      this.predictiveSearchResults?.classList.remove('active');
      return;
    }

    const clearButton = this.container?.querySelector('.aa-ClearButton');
    if (clearButton) {
      clearButton.click();
      return;
    }

    const input = this.getSearchInput();
    if (input) {
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.blur();
    }
  }

  categoryToggle() {
    this.category_toggle = this.container.querySelectorAll('.search-categories a');

    this.category_toggle.forEach((link) => {
      link.addEventListener('click', (event) => {
        [].forEach.call(this.category_toggle, function (el) {
          el.classList.remove('active');
        });
        link.classList.add('active');
        let target = link.getAttribute('href');
        this.container.querySelectorAll('.search-results').forEach((section) => {
          section.classList.remove('active');
        });
        this.container.querySelector(target).classList.add('active');

        event.preventDefault();
      });
    });

  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.predictiveSearchResults?.classList.remove('active');
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    this.predictiveSearchResults?.classList.add('loading');

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`)
      .then((response) => {
        this.predictiveSearchResults?.classList.remove('loading');
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    if (this.predictiveSearchResults) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.predictiveSearchResults.classList.add('active');
    }
    this.categoryToggle();
  }

  open() {
    document.querySelector('.header-section').classList.add('search-open');
  }

  close() {
    document.querySelector('.header-section')?.classList.remove('search-open');
    this.closeAlgoliaPanel();
  }
}
window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
});